var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeniorityLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7321_9367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7321_9367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 13.8333V11.5C4.83333 11.3111 4.89722 11.1528 5.025 11.025C5.15278 10.8972 5.31111 10.8333 5.5 10.8333H7.83333V8.5C7.83333 8.31111 7.89722 8.15278 8.025 8.025C8.15278 7.89722 8.31111 7.83333 8.5 7.83333H10.8333V5.5C10.8333 5.31111 10.8972 5.15278 11.025 5.025C11.1528 4.89722 11.3111 4.83333 11.5 4.83333H13.8333V3.16667C13.8333 2.97778 13.8972 2.81944 14.025 2.69167C14.1528 2.56389 14.3111 2.5 14.5 2.5C14.6889 2.5 14.8472 2.56389 14.975 2.69167C15.1028 2.81944 15.1667 2.97778 15.1667 3.16667V5.5C15.1667 5.68889 15.1028 5.84722 14.975 5.975C14.8472 6.10278 14.6889 6.16667 14.5 6.16667H12.1667V8.5C12.1667 8.68889 12.1028 8.84722 11.975 8.975C11.8472 9.10278 11.6889 9.16667 11.5 9.16667H9.16667V11.5C9.16667 11.6889 9.10278 11.8472 8.975 11.975C8.84722 12.1028 8.68889 12.1667 8.5 12.1667H6.16667V14.5C6.16667 14.6889 6.10278 14.8472 5.975 14.975C5.84722 15.1028 5.68889 15.1667 5.5 15.1667H3.16667C2.97778 15.1667 2.81944 15.1028 2.69167 14.975C2.56389 14.8472 2.5 14.6889 2.5 14.5C2.5 14.3111 2.56389 14.1528 2.69167 14.025C2.81944 13.8972 2.97778 13.8333 3.16667 13.8333H4.83333Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeniorityLevel);
export default __webpack_public_path__ + "static/media/seniorityLevel.90bd351a293983242ac328224745a94d.svg";
export { ForwardRef as ReactComponent };